import React, { useContext, useEffect, useMemo } from "react";
import { Context } from "../../index";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import PopupStation from "../../components/forms/popupStation";
import UniversalTable from "../../components/organization/table/UniTable";
import PageHeader from "../../components/header/pageheader/PageHeader";
import Modal from "../../components/forms/wrap/Modal";
import { isStationVisibleOnCards } from "../../utils/stationVisibility";

import "./styles.css";

export default observer(function AllStations() {
  const { store } = useContext(Context);
  const navigate = useNavigate();

  // ✅ Сортируем все станции по ID; `ОПР.1` скрывает станции с выключенным опросом
  const itemsToDisplay = useMemo(() => {
    return [...store.stations]
      .filter(isStationVisibleOnCards)
      .sort((a, b) => a.id - b.id);
  }, [store.stations]);

  useEffect(() => {
    if (store.user.role === "root") {
      store.getAllStations();
    } else {
      if (store.plant?.id) {
        store.getStations(); // ← станции для конкретного завода
      } else {
        store.getOrgStations(); // ← станции для всей организации
      }
    }
  }, [store.plant?.id]); // ← оставляем — логика загрузки зависит от plant.id

  const handleCloseModal = () => {
    store.setStation({});
  };

  const handlePlantClick = (id: number, stationID: number) => {
    const curPlant = store.plants.find((el) => el.id === id);
    if (curPlant) {
      store.setPlant(curPlant);
      const curOrg = store.companies.find(
        (el) => el.id === curPlant.company_id,
      );
      store.setCompany(curOrg);
      navigate("/inplants");
    }
  };

  const handlePlantStay = (id: number, stationID: number) => {
    const curPlant = store.plants.find((el) => el.id === id);
    if (!curPlant) return;

    store.setPlant(curPlant);

    // ✅ Встроили selectStation сюда — убираем отдельную функцию
    const curStation = store.stations.find((el) => el.id === stationID);
    store.setStation(curStation);

    store.getLines();
    store.getModules();
  };

  return (
    <div className="all_station_container">
      <PageHeader title="СТАНЦИИ" />

      <UniversalTable
        data={itemsToDisplay}
        type="stations"
        Edit={handlePlantStay}
        setOrg={handlePlantClick}
      />

      <Modal isOpen={!!store.station?.id} onClose={handleCloseModal}>
        <PopupStation
          station={store.station}
          modules={store.modules}
          handleCloseModal={handleCloseModal}
          position="list"
          updateStation={(station, position) => store.updateStation(station, position)}
          restartStation={(id, controller) => store.restartStation(id, controller)}
          AvailabilityStation={(id, moduleId, controller, availability) => store.AvailabilityStation(id, moduleId, controller, availability)}
          UnlockConnector={(id, controller) => store.UnlockConnector(id, controller)}
          refreshData={() => {
            if (store.user.role === "root") {
              store.getAllStations();
            } else {
              if (store.plant?.id) {
                store.getStations();
              } else {
                store.getOrgStations();
              }
            }
          }}
        />
      </Modal>
    </div>
  );
});
